import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import {IocStore} from "./stores/ioc";
import LogsStore from "./stores/logs";
import UserStore from "./stores/user";
import NavWrapper from "./components/NavWrapper";
import HomePage from './pages/home'
import CheckIocPage from "./pages/checkIoc";
import CheckLogsPage from "./pages/checkLogs";
import CheckIocResultsPage from "./pages/checkIocResults";
import UsersPage from "./pages/users";
import UserDetailsPage from "./pages/userDetails";
import AuthPage from "./pages/auth";
import {HotIocStore, WorstCountryStore, WorstIpStore} from "./stores/stats";
import ValidatePage from "./pages/validate";
import ReportPage from "./pages/report";

let hsId: string = "notSet";

function App() {
    const iocStore = new IocStore()
    const logsStore = new LogsStore()
    const userStore = new UserStore()

    const worstIpStore = new WorstIpStore()
    const worstCountryStore = new WorstCountryStore()
    const hotIocStore = new HotIocStore()

    window.addEventListener("message", (e) => {
        if (e.origin !== "https://www.threatstop.com") return;
        if (e.data.indexOf('[iFrameSizer]') !== -1) return;

        hsId = e.data;
    }, false);

    return (
        <BrowserRouter>
            <Switch>
                <NavWrapper iocStore={iocStore} logsStore={logsStore}>
                    <Route exact path='/' render={() => <HomePage logsStore={logsStore} iocStore={iocStore} worstIpStore={worstIpStore} worstCountryStore={worstCountryStore} hotIocStore={hotIocStore}/>}/>
                    <Route exact path='/auth' render={() => <AuthPage logsStore={logsStore} iocStore={iocStore} hsId={hsId}/>}/>
                    <Route path='/check/:ioc' render={() => <CheckIocPage store={iocStore}/>}/>
                    <Route path='/ioc/:ioc' render={() => <CheckIocResultsPage store={iocStore}/>}/>
                    <Route path='/logs' render={() => <CheckLogsPage store={logsStore}/>}/>
                    <Route path='/report' render={() => <ReportPage store={iocStore}/>}/>
                    <Route path='/users' render={() => <UsersPage />}/>
                    <Route path='/view/user/:id' render={() => <UserDetailsPage store={userStore}/>}/>
                    <Route path='/validate/:token' render={() => <ValidatePage store={iocStore}/>}/>
                </NavWrapper>
            </Switch>

        </BrowserRouter>
    );
}

export default App;
